module.exports = __webpack_public_path__ + "static/3q3-4b31669691072378b77c7c84feb65b18.svg";